export type TYPE_GET_TRANSACTION_HASH = () => Promise<string>;
export type TYPE_GET_TRANSACTION_RECEIPT = <T_RECEIPT>() => Promise<T_RECEIPT>;
export type TYPE_TRANSACTION_WRITE_RESULT = [
    TYPE_GET_TRANSACTION_HASH, TYPE_GET_TRANSACTION_RECEIPT
];